import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Config from "config";
import Select from "react-select";
import FilePreview from "components/Common/previewFile";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentInvestissement";
import ImpressionCard from "components/Common/ImpressionCard";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";
import DeleteButton from "components/Common/DeleteButtonShow";

const InvestissmentDetail = () => {
  const api = Config.backOffice.apiName;

  const backUrl = Config.backOffice.url;
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [investData, setInvestData] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  // edit hm document
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const [selectedPme, setSelectedPme] = useState();
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investissements | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails investissements"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
        {investData?.hm_accessibles?.map((key, index) =>
          key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents_fusion" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents_fusions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents_fusions")}
              >
                {!loading ? (
                  documentFusionData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "send_webhook_agridom":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/investissements/${id}/send_webhook_agridom`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
          } else {
            toast.error("Une erreur s'est produite");
            throw new Error(donnee.message);
          }
        } catch (error) {
          toast.error("Une erreur s'est produite");
        }
        break;
      case "dossier_complet":
        toast.success("Dossier Complet ...");

        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.action}?investissement_id=${action.params.investissement_id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;
      case "generate_loyers":
        toast.success("Calcul en cours ...");

        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.action}?investissement_id=${action.params.investissement_id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const donnee = await response.json();
          if (response.status == 200) {
            toast.success(donnee.message);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  const [documentData, setDocumentData] = useState([]);
  const getDocumentHm = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements/${id}/hm_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocumentData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [documentFusionData, setDocumentFusionData] = useState([]);
  const getDocumentFusionHm = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements/${id}/hm_documents_fusion`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocumentFusionData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getDocumentDetail = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements_documents/${docId}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Catégorie"]
          );
          setSelectedPme(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Investissement"]
          );
          setSelectedType(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Type"]
          );
          setSelectedNom(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Nom"]
          );
          setSelectedFichier(
            data?.detail_investissements_document[
              "Identification du documents"
            ]["Fichier"]
          );
          setSelectedComment(
            data?.detail_investissements_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investissements_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorieData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();
      formData.append("investissement_id", id);
      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          getDocumentHm();
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            responseData &&
            responseData.investissements_document_validation
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.investissements_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);
        formData.append("investissement_id", id);
        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          getDocumentHm();
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  useEffect(() => {
    getTypeDoc();
    getCategorieDocument();
  }, [selectedCategories, newCategories]);
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const investData = await response.json();
        setInvestData(investData);
        {
          investData?.hm_accessibles?.map(async (key, index) =>
            key === "hm_documents"
              ? await getDocumentHm()
              : key === "hm_documents_fusion"
              ? await getDocumentFusionHm()
              : null
          );
        }
        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={
                              type_compte == "client"
                                ? `${backUrl}/pmes/${investData.detail_investissement?.["ids"]?.pme_id}`
                                : `${backUrl}/investissements`
                            }
                            style={{
                              color: "#555B21",
                              textDecoration: "underline !important",
                            }}
                          >
                            {type_compte == "client"
                              ? `${investData?.detail_investissement?.["Caractéristiques de l'investissement"]?.PME}`
                              : "Investissements"}
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investData.can_edit ? (
                        <Link
                          to={`${backUrl}/investissements/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {investData.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/investissements/${id}`}
                        />
                      ) : null}
                      {investData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {investData?.actions.map((value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {investData?.detail_investissement?.[
                                "Caractéristiques de l'investissement"
                              ] ? (
                                <IdentificationCard
                                  title="Caractéristiques de l'investissement"
                                  ids={investData?.detail_investissement?.ids}
                                  details={
                                    investData?.detail_investissement?.[
                                      "Caractéristiques de l'investissement"
                                    ]
                                  }
                                />
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Description"
                              ] ? (
                                <SouscriptionsCard
                                  title="Description"
                                  details={
                                    investData?.detail_investissement?.[
                                      "Description"
                                    ]
                                  }
                                />
                              ) : null}

                              {investData?.detail_investissement?.[
                                "Honoraires"
                              ] ? (
                                <SouscriptionsCard
                                  title="Honoraires"
                                  details={
                                    investData?.detail_investissement?.[
                                      "Honoraires"
                                    ]
                                  }
                                />
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Fusion documentaire"
                              ] ? (
                                <ImpressionCard
                                  title="Fusion documentaire"
                                  pme_id={
                                    investData.detail_investissement?.["ids"]
                                      ?.pme_id
                                  }
                                  details={
                                    investData?.detail_investissement?.[
                                      "Fusion documentaire"
                                    ]
                                  }
                                />
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Tableau des amortissements"
                              ] ? (
                                <Row>
                                  {investData?.detail_investissement?.Loyers ? (
                                    <Row>
                                      <Col sm="12">
                                        <CardTitle
                                          tag="h5"
                                          style={{ paddingBottom: "10px" }}
                                        >
                                          Loyers{" "}
                                        </CardTitle>
                                        <TableComponent
                                          header={
                                            investData?.detail_investissement
                                              ?.Loyers["Loyers investissement"]
                                              ?.header
                                          }
                                          data={
                                            investData?.detail_investissement
                                              ?.Loyers["Loyers investissement"]
                                              ?.data
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  ) : null}{" "}
                                  <Col sm="12">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      Tableau des amortissements{" "}
                                    </CardTitle>
                                    <TableComponent
                                      header={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.header
                                      }
                                      data={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.data
                                      }
                                    />
                                  </Col>
                                </Row>
                              ) : null}
                            </Col>

                            <Col sm="6">
                              <Row>
                                {investData?.detail_investissement?.[
                                  "Exploitation"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Exploitation"
                                    details={
                                      investData?.detail_investissement?.[
                                        "Exploitation"
                                      ]
                                    }
                                    ids={investData?.detail_investissement?.ids}
                                  />
                                ) : null}
                                {investData?.detail_investissement?.[
                                  "Lot 1"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Lot 1"
                                    details={
                                      investData?.detail_investissement?.[
                                        "Lot 1"
                                      ]
                                    }
                                  />
                                ) : null}{" "}
                                {investData?.detail_investissement?.[
                                  "Lot 2"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Lot 2"
                                    details={
                                      investData?.detail_investissement?.[
                                        "Lot 2"
                                      ]
                                    }
                                  />
                                ) : null}
                                {investData?.detail_investissement?.[
                                  "Total"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Total"
                                    details={
                                      investData?.detail_investissement?.[
                                        "Total"
                                      ]
                                    }
                                  />
                                ) : null}
                                {investData?.detail_investissement?.Audit ? (
                                  <SectionCard
                                    title="Audit"
                                    details={
                                      investData?.detail_investissement?.Audit
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>

                            <>
                              {investData?.detail_pme?.documents.map(
                                (section, index) => (
                                  <Col
                                    sm={Math.min(
                                      Math.floor(
                                        12 /
                                          investData?.detail_pme?.documents
                                            .length
                                      ),
                                      12
                                    )}
                                  >
                                    <Row>
                                      <Card key={`section_${index}`}>
                                        <CardBody>
                                          <CardTitle
                                            className="mb-3"
                                            style={{ whiteSpace: "pretty" }}
                                          >
                                            {section.section_name}
                                          </CardTitle>

                                          {section.data.map((file, i) => (
                                            <Row
                                              key={`_file_${i}`}
                                              style={{
                                                borderBottom: "1px solid #eee",
                                                padding: "10px 0",
                                              }}
                                            >
                                              <Col
                                                xs={2}
                                                style={{ display: "" }}
                                              >
                                                <div className="avatar-sm">
                                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                    <i className="bx bxs-file-doc" />
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={8}
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  href={`https://www.fluxod.com/${api}/${
                                                    file?.link?.controller
                                                  }/${file?.link?.action}&${
                                                    Object.keys(
                                                      file.link.params
                                                    )[0]
                                                  }=${
                                                    file?.link?.params?.[
                                                      Object.keys(
                                                        file.link.params
                                                      )[0]
                                                    ]
                                                  }`}
                                                  className="text-dark"
                                                  style={{
                                                    textDecoration: "none",
                                                    display: "block",
                                                  }}
                                                >
                                                  <h5
                                                    className="font-size-14 mb-1"
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.nom}
                                                  </h5>
                                                  <small
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.type}
                                                  </small>
                                                </a>
                                              </Col>
                                              <Col xs={2}>
                                                <div
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  {file.link && (
                                                    <a
                                                      href={`https://www.fluxod.com/${api}/${
                                                        file?.link?.controller
                                                      }/${file?.link?.action}&${
                                                        Object.keys(
                                                          file.link.params
                                                        )[0]
                                                      }=${
                                                        file?.link?.params?.[
                                                          Object.keys(
                                                            file.link.params
                                                          )[0]
                                                        ]
                                                      }`}
                                                      className="text-dark"
                                                    >
                                                      <i className="bx bx-download h3 m-0" />
                                                    </a>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  </Col>
                                )
                              )}
                            </>

                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          {documentData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_1(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}
                          <DocumentHm
                            title={documentData}
                            data={documentData?.data}
                            header={documentData?.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getDocumentDetail(documentId);
                              getTypeDoc(documentId);
                              setDocId(documentId);
                            }}
                            controller="investissements_documents"
                          />
                          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                            <ModalHeader
                              toggle={() => setModal(!modal)}
                              tag="h4"
                            >
                              Détails du document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  setModal(false);
                                  handleUpdateSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investissement
                                      </Label>
                                      <Input
                                        name="investissement"
                                        type="text"
                                        placeholder="Investissement"
                                        value={selectedPme}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={selectedCategories}
                                        onChange={handleCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={selectedType}
                                        onChange={handleTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={selectedNom}
                                        onChange={(e) =>
                                          setSelectedNom(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={selectedComment}
                                        onChange={(e) =>
                                          setSelectedComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier :
                                      </Label>
                                      <FilePreview
                                        fileUrl={
                                          docData
                                            ?.detail_investissements_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                      />
                                      <a
                                        href={
                                          docData
                                            ?.detail_investissements_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Télécharger le fichier
                                      </a>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success save-user"
                                      >
                                        Enregistrer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_1}
                            toggle={() => setModal_1(!modal_1)}
                          >
                            <ModalHeader
                              toggle={() => setModal_1(!modal_1)}
                              tag="h4"
                            >
                              Nouveau document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investissement
                                      </Label>
                                      <Input
                                        name="investissement"
                                        type="text"
                                        placeholder="investissement"
                                        value={investData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={newCategories}
                                        onChange={handleNewCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={newNom}
                                        onChange={handleNomChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={newComment}
                                        onChange={(e) =>
                                          setNewComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier
                                      </Label>

                                      <input
                                        type="file"
                                        onChange={handleNewFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents_fusions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <DocumentFusionHm
                            title={documentFusionData}
                            data={documentFusionData?.data}
                            header={documentFusionData?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default InvestissmentDetail;
